"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutParagraphMarkBox = void 0;
var tslib_1 = require("tslib");
var measure_info_1 = require("../../../measurer/measure-info");
var rich_utils_1 = require("../../../model/rich-utils");
var layout_box_1 = require("./layout-box");
var LayoutParagraphMarkBox = (function (_super) {
    tslib_1.__extends(LayoutParagraphMarkBox, _super);
    function LayoutParagraphMarkBox(characterProperties, colorInfo, isLastParagraphInCell) {
        var _this = _super.call(this, characterProperties, colorInfo) || this;
        _this.isLastParagraphInCell = isLastParagraphInCell;
        return _this;
    }
    LayoutParagraphMarkBox.prototype.equals = function (obj) {
        return _super.prototype.equals.call(this, obj) &&
            this.paragraphMarkSymbol == obj.paragraphMarkSymbol &&
            this.isLastParagraphInCell == obj.isLastParagraphInCell;
    };
    LayoutParagraphMarkBox.prototype.clone = function () {
        var newObj = new LayoutParagraphMarkBox(this.characterProperties, this.colorInfo, this.isLastParagraphInCell);
        newObj.copyFrom(this);
        return newObj;
    };
    LayoutParagraphMarkBox.prototype.copyFrom = function (obj) {
        _super.prototype.copyFrom.call(this, obj);
        this.paragraphMarkSymbol = obj.paragraphMarkSymbol;
        this.isLastParagraphInCell = obj.isLastParagraphInCell;
    };
    LayoutParagraphMarkBox.prototype.getType = function () {
        return layout_box_1.LayoutBoxType.ParagraphMark;
    };
    LayoutParagraphMarkBox.prototype.pushInfoForMeasure = function (info, _showHiddenSymbols) {
        info.push(new measure_info_1.MeasureInfoNonText(this.getSymbolForMesure(), this.characterProperties));
    };
    LayoutParagraphMarkBox.prototype.popInfoForMeasure = function (info, showHiddenSymbols) {
        this.paragraphMarkSymbol = this.getSymbol(showHiddenSymbols);
        this.setSize(info.pop().resultSize);
    };
    LayoutParagraphMarkBox.prototype.renderGetContent = function (_renderer) {
        return this.paragraphMarkSymbol;
    };
    LayoutParagraphMarkBox.prototype.renderNoStrikeoutAndNoUnderlineIfBoxInEndRow = function () {
        return true;
    };
    LayoutParagraphMarkBox.prototype.isWhitespace = function () {
        return false;
    };
    LayoutParagraphMarkBox.prototype.isLineBreak = function () {
        return true;
    };
    LayoutParagraphMarkBox.prototype.getSymbolForMesure = function () {
        if (this.isLastParagraphInCell)
            return rich_utils_1.RichUtils.specialCharacters.CurrencySign;
        return rich_utils_1.RichUtils.specialCharacters.HiddenParagraphMark;
    };
    LayoutParagraphMarkBox.prototype.getSymbol = function (showHiddenSymbols) {
        if (!showHiddenSymbols)
            return "&nbsp;";
        return this.getSymbolForMesure();
    };
    return LayoutParagraphMarkBox;
}(layout_box_1.LayoutBox));
exports.LayoutParagraphMarkBox = LayoutParagraphMarkBox;
